import { AppTheme } from '@/plugins/vuetify/themes/types';

export interface Environment {
    name: string;
    apiUrl: string;
}

export interface AppBarSettings {
    visible: boolean;
}

export interface AppWindowSettings {
    mode: string;
}

export class AppWindowMode {
    static values = [
        'Calendar',
        'Form',
        'router-view',
        'AdminMode',
        'ScheduleBoard',
        'LandingPageForm',
        'EventRegistrationCancellation',
        'EventTicketChange',
        'MarathonRegistration',
        'ArtistRegistration',
    ];
}

export interface ConfigurationState {
    appBarSettings: AppBarSettings;
    appWindowSettings: AppWindowSettings;
    environments: { [name: string]: Environment };
    appThemes: { [name: string]: AppTheme };
    environment: Environment;
    appTheme: AppTheme;
}
